export default {
  api: {
    host: process.env.REACT_APP_API_HOST,
  },
  secret_key: process.env.REACT_APP_ENCODE_KEY,
  public_key: process.env.REACT_APP_PUBLIC_KEY,
};
